import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=819cc546&scoped=true"
import script from "./HomeProducts.vue?vue&type=script&lang=js"
export * from "./HomeProducts.vue?vue&type=script&lang=js"
import style0 from "./HomeProducts.vue?vue&type=style&index=0&id=819cc546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819cc546",
  null
  
)

export default component.exports